import * as types from './types';

export const setSharing = payload => ({
  type: types.SET_SHARING,
  payload,
});

